import React, {Component} from 'react';
import {Layout} from 'antd';
import styled from 'styled-components';
import ModernHero from './landing/ModernHero';
import ModernFeatures from './landing/ModernFeatures';
import VideoSection from './landing/VideoSection';
import {LandingInfo} from './landing/landingInfo';
import DemoSection from './landing/DemoSection';
import Widget from './landing/Widget';
import WishList from './landing/wishList';
import ReactGA from 'react-ga';

// Initialize Google Analytics
ReactGA.initialize('UA-172737566-1');

// Track visitors to each pageview
ReactGA.pageview(window.location.pathname + window.location.search);

const {Content} = Layout;

// Styled Components
const LandingContainer = styled.div`
  background: ${props => props.theme.colors?.neutral?.[950] || '#0a0a0a'};
  min-height: 100vh;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  position: relative;
`;

const MainContent = styled(Content)`
  background: transparent;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100vw;
`;

// Get RSS feed link safely
const getRSSFeedLink = () => {
  if (typeof document !== 'undefined') {
    const el = document.getElementById('medium-posts-widget');
    return el ? el.getAttribute('data-medium-rss') : null;
  }
  return null;
};

class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      isLoaded: false,
    };
  }

  componentDidMount() {
    // Set loaded state for animations
    this.setState({isLoaded: true});

    // Track page view
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    const rssFeedLink = getRSSFeedLink();

    return (
      <LandingContainer>
        <Layout style={{width: '100%', maxWidth: '100vw', background: 'transparent'}}>
          <MainContent>
            {/* Modern Hero Section with Glassmorphism */}
            <ModernHero />

            {/* Modern Features Section */}
            <ModernFeatures />

            {/* Enhanced Video Section */}
            <VideoSection />

            {/* Redesigned Landing Info */}
            <LandingInfo />

            {/* Interactive Demo Section */}
            <DemoSection />

            {/* Blog Widget */}
            <Widget mediumRSSFeedLink={rssFeedLink} />

            {/* Modern Waitlist Section */}
            <WishList />
          </MainContent>
        </Layout>
      </LandingContainer>
    );
  }
}

export default LandingPage;
